// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import i18n from '../../i18n/nl-NL';

import admarktRegistration from './AdmarktRegistration';

// Tenant-specific styles
import '../../../scss/site/pages/AdmarktRegistration/AdmarktRegistration.scss';

admarktRegistration(i18n);
